import {TemplateRef} from '@angular/core';

export abstract class ContainerCustomizer<T> {

    private beforeTmpl: Map<string, TemplateRef<T>> = new Map<string, TemplateRef<T>>();
    private replaceTmpl: Map<string, TemplateRef<T>> = new Map<string, TemplateRef<T>>();
    private afterTmpl: Map<string, TemplateRef<T>> = new Map<string, TemplateRef<T>>();

    public addBefore(key: string, template: TemplateRef<T>): void {
        this.beforeTmpl.set(key, template);
    }

    public hasBefore(key: string): boolean {
        return this.beforeTmpl.has(key);
    }

    public getBefore(key: string): TemplateRef<T> {
        return this.beforeTmpl.get(key);
    }

    public replace(key: string, template: TemplateRef<T>): void {
        this.replaceTmpl.set(key, template);
    }

    public hasReplacement(key: string): boolean {
        return this.replaceTmpl.has(key);
    }

    public getReplacement(key: string): TemplateRef<T> {
        return this.replaceTmpl.get(key);
    }

    public addAfter(key: string, template: TemplateRef<T>): void {
        this.afterTmpl.set(key, template);
    }

    public hasAfter(key: string): boolean {
        return this.afterTmpl.has(key);
    }

    getAfter(key: string): TemplateRef<T> {
        return this.afterTmpl.get(key);
    }

    showOriginal(item: string): boolean {
        return !this.hasReplacement(item);
    }
}
